import projection from '../generated/pwn5m3f1.json';
import { AcceptanceManifest } from '../types';
export const pwn5m3f1AcceptanceManifest = projection as AcceptanceManifest;
